import { render, staticRenderFns } from "./BlockSpacer.vue?vue&type=template&id=bf138d66&"
import script from "./BlockSpacer.vue?vue&type=script&lang=js&"
export * from "./BlockSpacer.vue?vue&type=script&lang=js&"
import style0 from "./BlockSpacer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports